import { Form, Header, Image, Message } from "semantic-ui-react";
import moment from "moment";
import { CREATE_USER } from "../graphQueries";
import { useEffect, useState } from "react";
import { useLazyQuery, useMutation } from "@apollo/client";
import Widget from "../Common/Widget";
import {
  CitySelect,
  CountrySelect,
  StateSelect,
  LanguageSelect,
  RegionSelect,
  PhonecodeSelect,
} from "react-country-state-city";
import "react-country-state-city/dist/react-country-state-city.css";

const SignUp = (props) => {
  const [selectedUser, setSelectedUser] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    street1: "",
    city: "",
    state: "",
    zipCode: "",
    role: "",
  });
  const [errorFields, setErrorFields] = useState({
    firstName: false,
    lastName: false,
    email: false,
    phone: false,
    street1: false,
    city: false,
    state: false,
    zipCode: false,
    role: false,
  });
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [submitDisabled, setSubmitDisabled] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const roles = [
    { text: "CSR", value: "CSR" },
    { text: "Attorney", value: "Attorney" },
    { text: "Agency", value: "Agency" },
    { text: "Videographer", value: "Videographer" },
  ];

  const handleChangeFieldString = (e, data) => {
    // reset error
    resetError(data.id);
    let key = data.id;
    let value = data.value;
    let obj = { ...selectedUser };
    Object.assign(obj, { [key]: value });
    setSelectedUser(obj);
  };

  const handleChangeDropdown = (id, selectedObj) => {
    let obj = { ...selectedUser };
    if (id === "city") {
      Object.assign(obj, {
        cityId: JSON.stringify(selectedObj),
        city: selectedObj.name,
      });
    }
    if (id === "state") {
      Object.assign(obj, {
        stateId: JSON.stringify(selectedObj),
        state: selectedObj.name,
      });
    }
    setSelectedUser(obj);
  };

  useEffect(() => {
    console.log(selectedUser);
  }, [selectedUser]);

  const handleSubmit = () => {
    setSubmitDisabled(true);
    setSubmitting(true);
    // validate form
    let errorObj = { ...errorFields };
    if (!selectedUser.firstName) Object.assign(errorObj, { firstName: true });
    if (!selectedUser.lastName) Object.assign(errorObj, { lastName: true });
    if (!selectedUser.email) Object.assign(errorObj, { email: true });
    if (!selectedUser.phone) Object.assign(errorObj, { phone: true });
    if (!selectedUser.street1) Object.assign(errorObj, { street1: true });
    if (!selectedUser.city) Object.assign(errorObj, { city: true });
    if (!selectedUser.state) Object.assign(errorObj, { state: true });
    if (!selectedUser.zipCode) Object.assign(errorObj, { zipCode: true });
    if (!selectedUser.role) Object.assign(errorObj, { role: true });
    setErrorFields(errorObj);
    const isError = Object.values(errorObj).some(
      (value) => typeof value === "boolean" && value === true
    );
    if (isError) {
      setSubmitDisabled(false);
      setSubmitting(false);
      return;
    }
    // no errors, continue with submitting
    Object.assign(selectedUser, {
      fullName: `${selectedUser.firstName} ${selectedUser.lastName}`,
    });
    createUser({ variables: selectedUser });
  };

  const [createUser] = useMutation(CREATE_USER, {
    onCompleted: (result) => handleCreateUser_Result(result),
    onError: (error) => handleCreateUser_Error(error),
  });

  const handleCreateUser_Result = (result) => {
    console.log(result);
    if (result && result.createUser.status === "succeeded") {
      setSuccess(true);
      setSubmitDisabled(false);
      setSubmitting(false);
    } else {
      setError(result.createUser.message);
    }
  };

  const handleCreateUser_Error = (error) => {
    console.log(error);
    setError(error.message);
    setSubmitDisabled(false);
    setSubmitting(false);
  };

  const resetError = (id) => {
    let obj = { ...errorFields };
    Object.assign(obj, { [id]: false });
    setErrorFields(obj);
    setError(false);
  };

  return (
    <div>
      <Image
        onClick={() => (window.location.href = "/")}
        src="./images/logo.png"
        style={{
          position: "absolute",
          width: "200px",
          top: "10px",
          left: "10px",
          zIndex: 1,
          cursor: "pointer",
        }}
      />
      <div
        style={{
          position: "absolute",
          bottom: "2px",
          left: "5px",
          zIndex: 1,
        }}
      >
        <span style={{ color: "#000000", fontSize: "10px" }}>
          &copy; {moment().format("YYYY")} Stenexus, LLC. All Rights Reserved.
        </span>
      </div>
      <div
        style={{
          backgroundColor: "#cccccc",
          width: "100%",
          height: "100%",
          position: "absolute",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {!success && (
          <div
            style={{
              width: "400px",
              maxHeight: "80%",
              backgroundColor: "#F1F1F1",
              borderRadius: "10px",
              padding: "10px",
              overflow: "auto",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                padding: "20px",
              }}
            >
              <Header content="Create Your Account" />
            </div>
            <Form size="large">
              <Form.Select
                error={errorFields.role}
                required
                id="role"
                label="User Type"
                placeholder="User Type"
                options={roles}
                value={selectedUser.role}
                onChange={handleChangeFieldString}
              />
              <Form.Input
                required
                error={errorFields.firstName}
                id="firstName"
                label="First Name"
                placeholder="First Name"
                value={selectedUser.firstName}
                onChange={handleChangeFieldString}
              />
              <Form.Input
                required
                error={errorFields.lastName}
                id="lastName"
                label="Last Name"
                placeholder="Last Name"
                value={selectedUser.lastName}
                onChange={handleChangeFieldString}
              />
              <Form.Input
                error={errorFields.email}
                required
                id="email"
                label="Email"
                placeholder="Email"
                value={selectedUser.email}
                onChange={handleChangeFieldString}
              />
              <Form.Input
                error={errorFields.phone}
                required
                id="phone"
                label="Phone"
                placeholder="Phone"
                value={selectedUser.phone}
                onChange={handleChangeFieldString}
              />
              <Form.Input
                error={errorFields.street1}
                required
                id="street1"
                label="Street"
                placeholder="Street"
                value={selectedUser.street1}
                onChange={handleChangeFieldString}
              />

              <Form.Field required>
                <label>State</label>
                <StateSelect
                  countryid={233}
                  onChange={(state) => {
                    setSelectedState(state);
                    handleChangeDropdown("state", state);
                  }}
                  defaultValue={selectedState}
                  placeHolder="Select State"
                />
              </Form.Field>
              <Form.Field required>
                <label>City</label>
                <CitySelect
                  inputClassName="ui input menu transition"
                  placeHolder="Select City"
                  countryid={233}
                  stateid={selectedState?.id}
                  disabled={!selectedState?.id}
                  onChange={(city) => {
                    setSelectedCity(city);
                    handleChangeDropdown("city", city);
                  }}
                  defaultValue={selectedCity}
                />
              </Form.Field>
              {/* <Form.Input
                error={errorFields.city}
                required
                id="city"
                label="City"
                placeholder="City"
                value={selectedUser.city}
                onChange={handleChangeFieldString}
              />
              <Form.Select
                error={errorFields.state}
                required
                search
                id="state"
                label="State"
                placeholder="State"
                value={selectedUser.state}
                options={states}
                onChange={handleChangeFieldString}
              /> */}
              <Form.Input
                error={errorFields.zipCode}
                required
                id="zipCode"
                label="Zip Code"
                placeholder="Zip Code"
                value={selectedUser.zipCode}
                onChange={handleChangeFieldString}
              />

              {error && <Message visible error content={error} />}
              <Form.Button
                loading={submitting}
                disabled={submitDisabled}
                content="Submit"
                size="large"
                fluid
                primary
                onClick={handleSubmit}
              />
            </Form>
          </div>
        )}
        {success && (
          <Message
            visible
            success
            content="Account Created! Please check your inbox for your activation link."
          />
        )}
      </div>
    </div>
  );
};
export default SignUp;
